<router-outlet></router-outlet>
<sob-global-error-modal></sob-global-error-modal>
